import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class ModuleCrash extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.ModuleCrash.ComponentDidMount", new Date(), Tools.getURLPath());        
    }
    
    // Here is our official route failed to load message
    render() {
        return (
            <div className="container-fluid body-content module-crash-container">
                <div className="row">
                    <div className="col-12 maxWidth-content ">
                        <div className="section-error-container">
                            <div className="row">
                                <div className="col-12 align-self-center">
                                    <div className="row section-error__body">
                                        <div className="col-12">
                                            <div className="section-error__body--message">
                                                <span className="icon-info" /> We were not able to load the page. Please try again.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    }

}

export default ModuleCrash;
